module.exports = __webpack_public_path__ + "static/media/bg-map.627a0d83.jpg";